module.exports = __webpack_public_path__ + "img/Partners6.c1035461.png";